import { render, staticRenderFns } from "./downloadPopup.vue?vue&type=template&id=2f901eb0&scoped=true&"
import script from "./downloadPopup.vue?vue&type=script&lang=js&"
export * from "./downloadPopup.vue?vue&type=script&lang=js&"
import style0 from "./downloadPopup.vue?vue&type=style&index=0&id=2f901eb0&prod&lang=scss&scoped=true&"
import style1 from "./downloadPopup.vue?vue&type=style&index=1&id=2f901eb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f901eb0",
  null
  
)

export default component.exports